import * as React from 'react';

function SvgHeroBanner(props) {
  return (
    <svg viewBox="0 0 240 178" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M124.637 177.23c54.975 0 99.542-2.656 99.542-5.933 0-3.277-44.567-5.933-99.542-5.933s-99.541 2.656-99.541 5.933c0 3.277 44.566 5.933 99.541 5.933z"
        fill="#EFDBFF"
      />
      <path
        d="M127.986 167.122h-6.699c-.213 0-.386-1.941-.386-4.333v-47.147c0-2.393.173-4.333.386-4.333h6.699c.214 0 .386 1.94.386 4.333v47.147c0 2.392-.172 4.333-.386 4.333z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        d="M79.015 167.441l-2.538-2.538c-.08-.081 1.475-1.768 3.474-3.767l39.387-39.386c1.999-2 3.686-3.555 3.766-3.475l2.538 2.538c.081.081-1.475 1.768-3.474 3.767l-39.387 39.387c-1.999 1.999-3.685 3.554-3.766 3.474z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        d="M171.348 167.925l2.538-2.538c.081-.081-1.492-1.785-3.512-3.805l-39.795-39.795c-2.02-2.02-3.724-3.592-3.804-3.512l-2.538 2.538c-.081.081 1.492 1.785 3.511 3.805l39.796 39.795c2.019 2.019 3.723 3.592 3.804 3.512z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        d="M213.897 134.599H35.377c-5.196 0-9.403-4.194-9.403-9.358V13.871c0-5.163 4.207-9.357 9.403-9.357h178.52c5.195 0 9.403 4.194 9.403 9.357v111.37c0 5.164-4.208 9.358-9.403 9.358z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        d="M51.18 85.457l-5.335 5.33-2.593-2.584m19.49-5.297h15.77m33.613 0h15.771m32.911-.144h27.818m-27.818 18.103h27.818M62.865 90.73h26.078m23.305 0h26.079m22.47-.076h40.733m-40.733 18.104h40.733m-150.35-5.045l-5.335 5.33-2.593-2.584m19.49-5.297h15.77m33.613 0h15.771m-65.032 7.824h26.08m23.304 0h26.079"
        stroke="#D3ADF7"
        strokeWidth={2.417}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.508 170.636h-43.743c-.643 0-1.196-.068-1.562-.162a2.275 2.275 0 01-.078-.022v-6.224l.078-.022c.366-.094.919-.162 1.562-.162h43.743c.644 0 1.197.068 1.563.162l.078.022v6.224a2.275 2.275 0 01-.078.022c-.366.094-.919.162-1.563.162zm-45.607-.268c-.018-.011-.014-.011.001.001l-.001-.001zm0-6.056l.001-.001c-.015.012-.019.012-.001.001zm47.472 0c.018.011.014.011-.002-.001l.002.001zm0 6.056l-.002.001c.016-.012.02-.012.002-.001zm-61.311-6.324v6.592H72.119v-6.592h14.943zm90.092 0v6.592h-14.942v-6.592h14.942zM25.974 4.514H223.3v7.47H25.974v-7.47z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        d="M138.261 1h-28.127a3.296 3.296 0 000 6.592h28.127a3.296 3.296 0 000-6.592z"
        fill="#F9F0FF"
        stroke="#D3ADF7"
        strokeWidth={1.64}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.315 36.954v29.257c0 1.588 1.272 2.874 2.842 2.874h41.089-23.867l7.518-10.716c.358-.511 1.254-.511 1.613 0l2.632 3.752.02.03.018-.026 5.645-8.196c.39-.567 1.368-.567 1.759 0l7.475 10.856v1.434-29.265c0-1.588-1.274-2.874-2.841-2.874H44.157c-1.57 0-2.842 1.286-2.842 2.874z"
        fill="#D3ADF7"
      />
      <path d="M54.498 56.402a7.36 7.36 0 110-14.72 7.36 7.36 0 010 14.72z" fill="#F9F0FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.635 36.954v29.257c0 1.588 1.271 2.874 2.841 2.874h41.089-23.867l7.518-10.716c.358-.511 1.255-.511 1.613 0l2.632 3.752.021.03.017-.026 5.645-8.196c.391-.567 1.369-.567 1.759 0l7.476 10.856v1.431-29.262c0-1.588-1.275-2.874-2.842-2.874h-41.061c-1.57 0-2.841 1.286-2.841 2.874z"
        fill="#D3ADF7"
      />
      <path d="M112.817 56.402a7.36 7.36 0 110-14.72 7.36 7.36 0 010 14.72z" fill="#F9F0FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.954 36.954v29.257c0 1.588 1.271 2.874 2.841 2.874h41.089-23.866l7.517-10.716c.359-.511 1.255-.511 1.614 0l2.631 3.752.021.03.017-.026 5.646-8.196c.39-.567 1.368-.567 1.758 0l7.476 10.856v1.433-29.264c0-1.588-1.275-2.874-2.842-2.874h-41.061c-1.57 0-2.841 1.286-2.841 2.874z"
        fill="#D3ADF7"
      />
      <path d="M171.136 56.402a7.36 7.36 0 110-14.721 7.36 7.36 0 010 14.72z" fill="#F9F0FF" />
      <path
        d="M10.183 62.61C6.513 65.983.027 64.902.027 64.902s-.532-6.55 3.14-9.92c3.67-3.374 10.153-2.295 10.153-2.295s.532 6.55-3.137 9.923zM10.076 88a3.076 3.076 0 110 6.152 3.076 3.076 0 010-6.152z"
        fill="#EFDBFF"
      />
      <path
        d="M11.471 16.82c1.942 0 3.516 1.673 3.516 3.736s-1.574 3.736-3.516 3.736c-1.941 0-3.516-1.673-3.516-3.736s1.575-3.735 3.516-3.735z"
        fill="url(#hero-banner_svg__paint0_linear_908_26577)"
      />
      <path
        d="M224.178 112.627a4.395 4.395 0 10.001-8.789 4.395 4.395 0 00-.001 8.789zM229.509 31.845a1.436 1.436 0 102.774.742 1.436 1.436 0 00-2.774-.742zM3.371 119.386a1.435 1.435 0 102.773.743 1.435 1.435 0 00-2.773-.743z"
        fill="#EFDBFF"
      />
      <path d="M237.803 59.45a2.197 2.197 0 100-4.394 2.197 2.197 0 000 4.394z" fill="#D3ADF7" />
      <path
        d="M211.688 24.292h-.067c-.397 5.426-4.582 5.51-4.582 5.51s4.615.086 4.615 6.356c0-6.27 4.614-6.357 4.614-6.357s-4.183-.083-4.58-5.509z"
        fill="#EFDBFF"
      />
      <path
        d="M18.022 102h-.043c-.258 3.429-2.979 3.482-2.979 3.482s3 .055 3 4.018c0-3.963 3-4.018 3-4.018s-2.72-.053-2.978-3.482z"
        fill="#D3ADF7"
      />
      <defs>
        <linearGradient
          id="hero-banner_svg__paint0_linear_908_26577"
          x1={15.137}
          y1={8.897}
          x2={14.892}
          y2={28.683}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgHeroBanner;
